
export const articleProductsSliderOptions = (instance, options) => {
    // Check if custom slidesPerView is set via data attribute
    const customSlidesPerView = instance.getAttribute('data-slides-per-view');
    const slidesCount = customSlidesPerView ? parseInt(customSlidesPerView) : 4;

    return {
        modules: [...options.modules],
        followFinger: false,
        speed: 500,
        slidesPerView: "auto",
        spaceBetween: 12,
        breakpoints: {
            1024: {
                cssMode: false,
                spaceBetween: 8,
                slidesPerView: slidesCount < 4 ? slidesCount : 4,
            },

        },
    }
};
